import { CSSObject } from "@emotion/react";
import { mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const fieldsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  columnGap: 24,
  rowGap: 10,
  marginBottom: 24,
  [breakpoint.upTo("xs")]: {
    flexDirection: "column",
    flexWrap: "nowrap",
  },
};

export const passwordInputCss: CSSObject = {
  flex: 1,
  minWidth: 200,
};

export const submitButtonCss: CSSObject = {
  [breakpoint.upTo("xs")]: {
    width: "100%",
  },
};
